
import { importSync as i } from '@embroider/macros';
let d = window.define;
import "ember-cli-typescript/-embroider-implicit-modules.js";
import "ember-auto-import/-embroider-implicit-modules.js";
import "ember-cli-htmlbars/-embroider-implicit-modules.js";
import "@sentry/ember/-embroider-implicit-modules.js";
import "ember-classic-decorator/-embroider-implicit-modules.js";
import "@dashboard/i18n/-embroider-implicit-modules.js";
import "@dashboard/query-client/-embroider-implicit-modules.js";
import "@square/appointments-feature-upsell/-embroider-implicit-modules.js";
import "@square/dashboard-data/-embroider-implicit-modules.js";
import "@square/dashboard-utilities/-embroider-implicit-modules.js";
import "@square/ember-features/-embroider-implicit-modules.js";
